import { render, staticRenderFns } from "./changewarn.vue?vue&type=template&id=ace69b38&scoped=true"
import script from "./changewarn.vue?vue&type=script&lang=js"
export * from "./changewarn.vue?vue&type=script&lang=js"
import style0 from "./changewarn.vue?vue&type=style&index=0&id=ace69b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace69b38",
  null
  
)

export default component.exports